import * as sounds from "./sounds";

/** On-brand confirmation dialog — replaces window.confirm() everywhere.
 * One wire point for the click sound covers every confirm action in the
 * app (kick member, leave/delete channel, delete message, and anything
 * else that reuses this dialog). */
export default function ConfirmModal({
  title,
  body,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger,
  busy,
  onConfirm,
  onCancel,
}: {
  title: string;
  body?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="confirm-card" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-title">{title}</div>
        {body && <p className="confirm-body">{body}</p>}
        <div className="confirm-row">
          <button className="confirm-btn confirm-btn--cancel" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={`confirm-btn ${danger ? "confirm-btn--danger" : "confirm-btn--primary"}`}
            onClick={() => {
              sounds.playOnce(sounds.SOUND.click);
              onConfirm();
            }}
            disabled={busy}
          >
            {busy ? "…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
